
import React from 'react';
import { BlogAdminHeader } from './BlogAdminHeader';
import { BlogPostsSearch } from './BlogPostsSearch';
import { BlogPostsTable } from './BlogPostsTable';
import { EmptyPostsState } from './EmptyPostsState';
import { LoadingState } from '@/components/ui/loading-state';
import { BlogPost } from '@/services/blog/types';

interface BlogContentProps {
  posts: BlogPost[];
  isLoading: boolean;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  onCreatePost: () => void;
  onEditPost: (id: string) => void;
  onViewPost: (slug: string) => void;
  onDuplicatePost: (id: string) => void;
  onDeletePost: (id: string) => void;
}

export const BlogContent: React.FC<BlogContentProps> = ({
  posts,
  isLoading,
  searchQuery,
  setSearchQuery,
  onCreatePost,
  onEditPost,
  onViewPost,
  onDuplicatePost,
  onDeletePost,
}) => {
  return (
    <div className="space-y-6">
      <BlogAdminHeader onCreatePost={onCreatePost} />

      <BlogPostsSearch
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      {isLoading ? (
        <LoadingState title="Loading blog posts" />
      ) : posts.length === 0 ? (
        <EmptyPostsState
          hasSearchQuery={searchQuery.length > 0}
          onCreatePost={onCreatePost}
        />
      ) : (
        <div className="w-full">
          <BlogPostsTable
            posts={posts}
            onEdit={onEditPost}
            onView={onViewPost}
            onDuplicate={onDuplicatePost}
            onDelete={onDeletePost}
          />
        </div>
      )}
    </div>
  );
};
